<template>
	<div>
		<div class="mb-6 flex items-center justify-between">
      <h2 class="font-semibold text-lg text-black">Tareas</h2>
      <button
        @click="showModal = true"
        class="group text-tuin-100 border border-tuin-100 hover:bg-tuin-100 hover:text-white flex items-center justify-center gap-2 sm:px-4 sm:py-2.5 p-2.5 sm:rounded-lg rounded-full transition text-sm font-medium"
      >
        <svg class="only-dest" xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M4 0C4.21217 0 4.41566 0.0842856 4.56569 0.234315C4.71571 0.384344 4.8 0.587827 4.8 0.8V3.2H7.2C7.41217 3.2 7.61566 3.28429 7.76569 3.43431C7.91571 3.58434 8 3.78783 8 4C8 4.21217 7.91571 4.41566 7.76569 4.56569C7.61566 4.71571 7.41217 4.8 7.2 4.8H4.8V7.2C4.8 7.41217 4.71571 7.61566 4.56569 7.76569C4.41566 7.91571 4.21217 8 4 8C3.78783 8 3.58434 7.91571 3.43431 7.76569C3.28429 7.61566 3.2 7.41217 3.2 7.2V4.8H0.8C0.587827 4.8 0.384344 4.71571 0.234315 4.56569C0.0842856 4.41566 0 4.21217 0 4C0 3.78783 0.0842856 3.58434 0.234315 3.43431C0.384344 3.28429 0.587827 3.2 0.8 3.2H3.2V0.8C3.2 0.587827 3.28429 0.384344 3.43431 0.234315C3.58434 0.0842856 3.78783 0 4 0V0Z" class="fill-tuin-100 group-hover:fill-white"/>
        </svg>
        <svg class="only-mob fill-tuin-100 stroke-tuin-100 group-hover:fill-white group-hover:stroke-white transition" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M8 8H1H8Z"/>
          <path d="M8 1V8M8 8V15M8 8H15M8 8H1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="only-dest">Agregar Tarea</span>
      </button>
    </div>

    <div
      class="bg-gray-100 p-4 rounded-lg" 
      v-if="(props.notes != null && props.notes.length > 0)"
    >
      <div
        v-for="note in props.notes"
        :key="note.id"
        class="mb-3"
      >
        <div class="flex items-start gap-3">
          <label
            :for="'status-' + note.id"
            class="flex items-start gap-3 cursor-pointer"
          >
            
            <input
              :id="'status-' + note.id"
              :checked="note.status === 0"
              type="checkbox"
              class="w-4 h-4 mt-1 text-tuin_base-0 bg-gray-100 border-gray-300 rounded focus:ring-transparent"
              @change="toggleNoteStatus(note)"
            >

            <div class="flex flex-col">
              <span class="text-sm font-medium text-gray-900" :class="{ 'line-through': note.status === 0 }">
                {{ note.tittle }}
              </span>

              <span class="text-xs font-normal text-gray-500" :class="{ 'line-through': note.status === 0 }">
                {{ formattedDate(note.note_date) }}
              </span>
              <p class="text-xs font-normal text-gray-500" :class="{ 'line-through': note.status === 0 }">
                {{ note.note }}
              </p>
            </div>
          </label>
        </div>
      </div>
    </div>

		<div  
      class="flex flex-col items-center justify-center text-center py-8"
      v-else
    >
      <div class="flex justify-center items-center mb-3">
        <svg xmlns="http://www.w3.org/2000/svg" width="31" height="28" viewBox="0 0 31 28" fill="none">
					<path fill-rule="evenodd" clip-rule="evenodd" d="M19.4749 1.78604C20.741 0.642458 22.4582 0 24.2487 0C26.0393 0 27.7565 0.642458 29.0226 1.78604C30.2887 2.92962 31 4.48065 31 6.09792C31 7.71519 30.2887 9.26622 29.0226 10.4098L15.3455 22.7633C14.564 23.4692 14.1055 23.8833 13.5922 24.244C12.9886 24.6712 12.3398 25.0336 11.6458 25.3314C11.0604 25.5828 10.4433 25.769 9.39654 26.0842L4.5924 27.5297L3.43606 27.8787C2.97616 28.0174 2.48258 28.0376 2.01068 27.9371C1.53877 27.8365 1.1072 27.6193 0.764362 27.3096C0.421522 26.9999 0.180969 26.6101 0.0696783 26.1839C-0.0416119 25.7577 -0.0192382 25.3119 0.13429 24.8965L2.12112 19.5141C2.47004 18.5673 2.67622 18.01 2.95449 17.4799C3.28515 16.8548 3.68645 16.2688 4.15841 15.7218C4.55635 15.2608 5.01629 14.8454 5.79776 14.1396L19.4749 1.78604ZM4.54193 25.4877L8.63815 24.2531C9.77863 23.9093 10.2631 23.7622 10.7144 23.5681C11.2642 23.3302 11.7799 23.0424 12.2614 22.7047C12.6551 22.426 13.0184 22.1018 13.8691 21.3334L24.7836 11.4751C23.2872 10.9961 21.9288 10.22 20.8085 9.20388C19.6846 8.19178 18.8263 6.96486 18.2969 5.61347L7.38232 15.4718C6.53165 16.2388 6.17119 16.5657 5.86408 16.9225C5.48921 17.3566 5.17057 17.8224 4.90816 18.3199C4.69333 18.7275 4.5304 19.1651 4.14976 20.1952L2.78291 23.8976L4.54193 25.4877ZM20.0487 4.02858C20.0992 4.25648 20.1814 4.56643 20.3212 4.92716C20.743 6.01724 21.4332 7.00665 22.3398 7.82085C23.2408 8.63952 24.3357 9.26289 25.542 9.64405C25.9429 9.77037 26.286 9.8446 26.5383 9.89018L27.4928 9.02807C28.3482 8.25001 28.8274 7.19743 28.8252 6.10092C28.8231 5.00441 28.3399 3.95336 27.4815 3.178C26.6231 2.40265 25.4594 1.96621 24.2454 1.96429C23.0314 1.96238 21.8661 2.39513 21.0046 3.16777L20.0487 4.02858Z" fill="#737373"/>
				</svg>
      </div>
      <p class=" text-base text-gray-900">
        No tienes Tareas Asignadas para este Prospecto
      </p>
    </div>
		
		<LeadsNotesModal
      v-if="showModal"
      @close="showModal = false"
      @note-saved="(data) => {
        showModal = false;
        emit('note-saved', data);
      }"
      :leadId="props.leadId"
    />
	</div>
</template>
<script setup>
import { ref } from 'vue';
import axios from 'axios';
import { useStore } from 'vuex';
import LeadsNotesModal from './Modal/LeadsNotesModal.vue';
import { useDateFormat } from '@vueuse/core'

const store = useStore();
const session = ref(store.getters.getUserSession);

const props = defineProps({
  notes: {
    type: Array,
    default: () => [],
  },
  leadId: {
    type: Number,
    required: true,
  },
});
const emit = defineEmits(['note-saved']);
const formattedDate = (date) => useDateFormat(date, 'DD/MM/YYYY')

let showModal = ref(false);

async function toggleNoteStatus(note) {
  const previousStatus = note.status;
  const newStatus = note.status === 0 ? 1 : 0;
  note.status = newStatus;

  const url_link = `${process.env.VUE_APP_API_BASE_URL}/broker/lead/note/${note.id}/status-update`;

  try {
    const options = {
      headers: {
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };

    const response = await axios.put(url_link, { status: newStatus }, options);

    if (response.status === 200) {
      // Status actualizado exitosamente
    }
  } catch (error) {
    // Revertir al estado anterior en caso de error
    note.status = previousStatus;
    //console.error("Error al actualizar el estado de la nota:", error);
  }
}

</script>